// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_type_dropdown__3zVUd","dropdown--dense":"_type_dropdown--dense__1INBN"};